import * as _ from 'lodash';
import React from 'react';
import { OptionTypeBase } from 'react-select';

import { useStringArraySearchParam } from '../../../hooks';

interface Props {
  products: { supplementForm: string }[];
}

const UnknownRegex = /unknown/gi;
const OtherRegex = /other/gi;

function testNotUnknown(supplementForm: string) {
  return !UnknownRegex.test(supplementForm);
}

function testNotOther(supplementForm: string) {
  return !OtherRegex.test(supplementForm);
}

function formatOptionLabel(supplementForm: string) {
  return supplementForm
    .toLowerCase()
    .replace(/\[.*\]/g, '')
    .replace(/\(.*\)/g, '')
    .trim();
}

function supplementFormToOption(supplementForm: string): OptionTypeBase {
  return {
    label: formatOptionLabel(supplementForm),
    value: supplementForm.toLowerCase(),
  };
}

export default function SupplementFormCheckboxGroup(props: Props) {
  const { products } = props;
  const [
    filterSupplementForms,
    filterSupplementFormsActions,
  ] = useStringArraySearchParam('supplementForms');

  const options = Array.from(
    new Set<string>(
      (products ?? [])
        .map(({ supplementForm }) => supplementForm)
        .filter((supplementForm) => supplementForm) as string[]
    )
  )
    .filter(testNotOther)
    .filter(testNotUnknown)
    .map(supplementFormToOption);

  return (
    <div>
      {options.map(({ label, value }) => (
        <p className="is-block" key={value}>
          <label className="checkbox">
            <input
              type="checkbox"
              value={value}
              onClick={() =>
                filterSupplementForms.indexOf(value) !== -1
                  ? filterSupplementFormsActions.remove(value)
                  : filterSupplementFormsActions.add(value)
              }
              onChange={() => {}}
              checked={filterSupplementForms.indexOf(value) !== -1}
            />{' '}
            {label}
          </label>
        </p>
      ))}
    </div>
  );
}
